
import {Component, Prop, Vue} from 'vue-property-decorator';
import stores from '@/stores';
import {SweetModal} from 'sweet-modal-vue';
import GlobalFunctions from '@/GlobalFunctions';
import { disableSubmitButton } from '@/helpers/functions';
import { showToaster } from '@/components/DashboardComposer/helpers';

@Component({
  components: {
    SweetModal,
  },
})
export default class CreateLocation extends Vue {

  @Prop({default: false})
  emitCreated!: boolean;

  location: any = {
    name : '',
  };

  globalFunctions = new GlobalFunctions();
  form!: HTMLFormElement;
  isLoading: boolean = false;
  mounted() {
    this.form = document.getElementById('create-form-location')! as HTMLFormElement;
    // listen for escape button click
    document.addEventListener('keydown', this.keyDown);
    // listen for submit and validate form
    this.form.addEventListener('submit', (event: any) => {
      if(this.isLoading) return;
      this.isLoading = true;
      event.preventDefault();
      if (this.form.checkValidity() === true) {
        event.stopPropagation();
        this.onSubmit();
      }
      if (this.form.checkValidity() === false) {
        event.stopPropagation();
      }
      this.form.classList.add('was-validated');
    }, false);

  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.keyDown);
  }

  onSubmit() {
    return stores.Rooms.createNewItems(this.location)
      .then((response) => {
        if(response && response.data && response.data.id)
        {
          this.cancel();
          this.$router.push({name: 'zones.show', params: {id: response.data.id}});
          this.$emit('created');
        }
        if(response && response.response && response.response.status === 422)
        {
          const error = response?.response?.data?.errors?.name || 'Something went wrong.';
          showToaster('warning',  this.location.name, error);
        }
      })
      .catch((e) => {
        console.error(e);
      }).finally(() => {
        this.isLoading = false;
      });
  }

  keyDown(event: any) {
    if (event.key === 'Escape') {
      this.cancel();
    }
  }

  cancel() {
    // @ts-ignore
    this.$children[0].close(); // close modal
    this.form.classList.remove('was-validated'); // remove validation styles
  }
}
